<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" :rules="rules" ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单" prop="orderId">
              <el-select v-model.trim="formData.orderId" @change="orderChange" clearable filterable placeholder="请选择订单">
                <el-option v-for="(item, index) of orderList" :value="item.orderId"
                  :label="item.orderTitle + ' / ' + item.supplierName" :key="index">
                  <!-- <div class="order-line">
                    <div class="line-item">
                      <span>{{ item.orderTitle }}</span>
                      <span>{{ item.purchaser }}</span>
                    </div>
                    <div class="line-item">
                      <span>{{ item.supplierName }}</span>
                      <span>{{ item.orderId }}</span>
                    </div>
                  </div> -->
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deliveryDate" label="提货日期">
              <el-date-picker v-model="formData.deliveryDate" placeholder="请选择提货日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isVehicle" label="车辆预约">
              <el-radio-group v-model="formData.isVehicle">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item prop="specList" label="车辆列表">
            <el-button class="mb15" type="primary" @click="addSpecList">新增规格</el-button>
            <el-table :data="formData.specList">
              <el-table-column fixed="left" min-width="200" prop="specId" label="规格">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.specId`" :rules="[{ required: true, message: '请选择规格' }]">
                    <el-select v-model="row.specId" clearable filterable>
                      <el-option v-for="(item, index) of specList" :value="item.specId"
                        :label="item.specName + '(' + item.purchaseQuantity + ')'" :key="index">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" prop="deliveryPlan" label="计划提货数量">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.deliveryPlan`"
                    :rules="[{ required: true, message: '请输入计划提货数量' }]">
                    <el-input-number v-model="row.deliveryPlan" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" prop="vehicleKey" label="车牌号">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.vehicleKey`"
                    :rules="[{ required: formData.isVehicle === '1', message: '请输入车牌号' }]">
                    <!-- <el-input v-model="row.vehicleKey" placeholder="请输入车牌号" /> -->

                    <el-select v-model="row.vehicleKey" :filterable="true" :clearable="true" placeholder="输入车牌号/姓名搜索"
                      @change="id => carChange(id, row)">
                      <el-option v-for="(item, index) of carList" :value="`${item.vehicleKey}|${item.driverName}`"
                        :label="`${item.vehicleKey}(${item.driverName})`" :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" label="挂车号">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.vehicleGph`">
                    <el-input :readonly="true" v-model="row.vehicleGph" placeholder="请输入挂车号" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" label="司机姓名">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.driverName`">
                    <el-input :readonly="true" v-model="row.driverName" placeholder="请输入司机姓名" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="200" label="司机身份证">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.driverKey`">
                    <el-input :readonly="true" v-model="row.driverKey" placeholder="请输入司机身份证" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" label="司机手机号">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.driverMobile`">
                    <el-input :readonly="true" v-model="row.driverMobile" placeholder="请输入司机手机号" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="220" prop="vehicleStartAddress" label="提货库点">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.vehicleStartAddress`">
                    <!-- <el-select v-model="row.vehicleStartAddress" filterable>
                      <el-option :value="item.dicCode" :label="item.dicValue" v-for="(item, index) of vehicleStartAddressList"
                        :key="index"></el-option>
                    </el-select> -->
                    <el-input v-model="row.vehicleStartAddress" placeholder="请输入提货库点" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="220" prop="vehicleEndAddress" label="卸货库点">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.vehicleEndAddress`"
                    :rules="[{ required: true, message: '请选择卸货库点' }]">
                    <!-- <el-input v-model="row.vehicleEndAddress" placeholder="请输入卸货库点" /> -->
                    <el-select v-model="row.vehicleEndAddress" filterable placeholder="请选择卸货库点">
                      <el-option :value="item.warehouseId" :label="item.warehouseName"
                        v-for="(item, index) of warehouseList" :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column min-width="380" prop="fileList" label="附件">
                <template v-slot="{ row }">
                  <el-form-item>
                    <file-upload :readonly="!!deliveryId" v-model="row.fileList" :maxSize="20">
                      <template #tip>
                        <div></div>
                      </template>
                    </file-upload>
                  </el-form-item>
                </template>
              </el-table-column> -->
              <el-table-column fixed="right" label="操作">
                <template v-slot="{ $index }">
                  <el-button type="text" @click="deleteSpec($index)" class="del-btn">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="ygNotes">
              <el-input type="textarea" v-model="formData.ygNotes"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { deepClone } from '../../utils/utils'

export default {
  name: 'purchaseDeliveryAdd',
  data() {
    return {
      carList: [],
      vehicleStartAddressList: [],
      warehouseList: [],
      specList: [],
      formData: {
        orderId: '', // 标书/订单ID
        isVehicle: '',
        deliveryDate: '', // 提货日期
        ygNotes: '', // 备注
        fileList: [], // 附件列表
        specList: [] // 车辆列表
      },
      rules: {
        orderId: [{ required: true, message: '请选择订单', trigger: 'change' }],
        isVehicle: [{ required: true, message: '请选择车辆预约', trigger: 'change' }],
        specList: [{ required: true, type: 'array', message: '请添加车辆' }],
        deliveryDate: [{ required: true, message: '请选择提货日期', trigger: 'change' }]
      },
      orderList: [],
      tempDeliveryPrice: '' // 临时保存基差价
    }
  },
  created() {
    this.loadOrder()
    this.loadWarehouseList()
    this.loadCarList()
    if (this.deliveryId) {
      this.loadData()
    }
  },
  computed: {
    deliveryId() {
      return this.$route.query.deliveryId
    }
  },
  methods: {
    loadCarList() {
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByPage).then(res => {
        this.carList = res.list
      })
    },
    carChange(val, row) {
      const vehicleKey = val.split('|')[0]
      const carInfo = this.carList.find(item => item.vehicleKey === vehicleKey)
      if (carInfo) {
        row.driverName = carInfo.driverName
        row.driverMobile = carInfo.driverMobile
        row.driverKey = carInfo.driverKey
        row.vehicleGph = carInfo.vehicleGph
      } else {
        row.driverName = ''
        row.driverMobile = ''
        row.driverKey = ''
        row.vehicleGph = ''
      }
    },
    loadWarehouseList() {
      // managerType，1：油罐，2：非油罐
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.warehouseList = res.list
      })
    },
    addSpecList() {
      if (!this.formData.orderId) {
        this.$message.error('请选择订单')
        return
      }
      if (!this.formData.isVehicle) {
        this.$message.error('请选择车辆预约')
        return
      }
      this.formData.specList.push({
        specId: '', // 规格id
        // specName: '', // 品种规格
        // specXh: '', // 规格单位
        deliveryPlan: '', // 计划提货数量
        // deliveryQty: '', // 实际提货数量
        vehicleKey: '', // 车牌号
        vehicleGph: '', // 挂车号
        driverName: '', // 司机姓名
        driverKey: '', // 司机身份证
        driverMobile: '', // 司机手机号
        vehicleStartAddress: '', // 提货库点
        vehicleEndAddress: '', // 卸货库点
        fileList: [] // 附件列表
      })
    },
    loadOrder() {
      this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderByList, {
        orderState: '2',
        orderType: '1',
        createUserId: this.$store.state.user.userId
      }).then(res => {
        this.orderList = res.list || []
      })
    },
    loadData() {
      this.$axios.get(this.$apis.purchaseDelivery.selectYcDeliveryByDeliveryId, {
        params: { deliveryId: this.deliveryId }
      }).then(async res => {
        res.fileList = res.fileList || []
        res.specList.forEach(item => {
          item.fileList = item.fileList || []
          item.vehicleKey = `${item.vehicleKey}|${item.driverName}`
        })
        await this.orderChange(res.orderId)
        this.formData = res || {}
      })
    },
    async orderChange(val) {
      this.formData.specList = []
      return this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderByOrderId, {
        params: { orderId: val }
      }).then(async res => {
        this.specList = res.specList
      })
    },
    deleteSpec(index) {
      this.formData.specList.splice(index, 1)
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.purchaseDelivery.insertYcDelivery
        if (this.deliveryId) {
          url = this.$apis.purchaseDelivery.updateYcDelivery
        }
        const formData = deepClone(this.formData)
        formData.specList.forEach(item => {
          if (item.vehicleKey) {
            item.vehicleKey = item.vehicleKey.split('|')[0]
          }
        })
        this.$axios.post(url, formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style lang="scss">
.order-select {
  .el-select-dropdown__item {
    height: 68px !important;
    line-height: 68px !important;
  }
}

.order-line {
  display: flex;
  flex-direction: column;
  height: 68px !important;
  line-height: 68px !important;

  .line-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;

    span {
      line-height: 34px;
      font-size: 13px;
    }
  }
}
</style>

<style scoped lang='scss'>
.line-tips {
  display: flex;
  align-items: center;
  position: relative;
  height: 30px;
  padding-left: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 4px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    height: 20px;
    width: 3px;
    background: #409eff;
  }

  span {
    font-size: 14px;
  }
}

.tips {
  font-size: 12px;
  color: #AAA;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
